export default __webpack_public_path__ + "b640522d19e0109dfe21a5ecaa8bfcc6.png";